// InvoiceDetailsModal.js
import React from "react";
import { Modal, Table, Card, Typography, Row, Col, Tag, Divider } from "antd";
import { FileTextOutlined, UserOutlined, PhoneOutlined, EnvironmentOutlined, CalendarOutlined, FlagOutlined, ShoppingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import CustomModal from '../../components/common/CustomModal';

const { Title, Text } = Typography;

const InvoiceDetailsModal = ({
  isOpen,
  onCancel,
  selectedInvoice,
  productColumns,
}) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      open={isOpen}
      onCancel={onCancel}
      title={selectedInvoice ? `${t("invoice.invoice_details")} - ${selectedInvoice.code}` : t("invoice.invoice_details")}
      subtitle={selectedInvoice ? selectedInvoice.estadoinvoice : ""}
      icon={<FileTextOutlined />}
      width={900}
      centered
      style={{
        top: 20
      }}
    >
      {selectedInvoice && (
        <>
          {/* Tags con información adicional */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <Tag color={selectedInvoice.prioridad === 1 ? 'red' : selectedInvoice.prioridad === 2 ? 'green' : 'blue'}>
                <FlagOutlined /> Prioridad {selectedInvoice.prioridad}
              </Tag>
              <Tag color="blue">
                <CalendarOutlined /> {selectedInvoice.rdatereserve}
              </Tag>
              <Tag color="purple">
                {selectedInvoice.estadoinvoice}
              </Tag>
            </div>
          </div>

          {/* Contenido del modal */}
          <Row gutter={[24, 24]}>
              {/* Informacion del Destinatario */}
              <Col xs={24} md={12}>
                <Card style={{
                  borderRadius: '12px',
                  border: '1px solid #e0e6ff',
                  height: '100%'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '16px'
                  }}>
                    <Title level={4} style={{
                      color: '#253289',
                      margin: 0,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <UserOutlined /> Informacion del Destinatario
                    </Title>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div>
                      <Text strong style={{ color: '#253289' }}>Nombre:</Text>
                      <br />
                      <Text>{selectedInvoice.cname}</Text>
                    </div>
                    <div>
                      <Text strong style={{ color: '#253289' }}>Identidad:</Text>
                      <br />
                      <Text>{selectedInvoice.cidentity}</Text>
                    </div>
                    <div>
                      <Text strong style={{ color: '#253289' }}>Telefono:</Text>
                      <br />
                      <Text><PhoneOutlined style={{ color: '#52c41a', marginRight: '4px' }} />{selectedInvoice.consigneephone}</Text>
                    </div>
                    <div>
                      <Text strong style={{ color: '#253289' }}>Direccion:</Text>
                      <br />
                      <Text><EnvironmentOutlined style={{ color: '#1890ff', marginRight: '4px' }} />{selectedInvoice.address}</Text>
                    </div>
                  </div>
                </Card>
              </Col>

              {/* Informacion del Remitente */}
              <Col xs={24} md={12}>
                <Card style={{
                  borderRadius: '12px',
                  border: '1px solid #e0e6ff',
                  height: '100%'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                    borderRadius: '8px',
                    padding: '16px',
                    marginBottom: '16px'
                  }}>
                    <Title level={4} style={{
                      color: '#253289',
                      margin: 0,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <UserOutlined /> Informacion del Remitente
                    </Title>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div>
                      <Text strong style={{ color: '#253289' }}>Nombre:</Text>
                      <br />
                      <Text>{selectedInvoice.sname}</Text>
                    </div>
                    <div>
                      <Text strong style={{ color: '#253289' }}>Telefono:</Text>
                      <br />
                      <Text><PhoneOutlined style={{ color: '#52c41a', marginRight: '4px' }} />{selectedInvoice.shipperphone}</Text>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>

            <Divider style={{ margin: '24px 0' }} />

            {/* Tabla de Productos */}
            <Card style={{
              borderRadius: '12px',
              border: '1px solid #e0e6ff'
            }}>
              <div style={{
                background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px'
              }}>
                <Title level={4} style={{
                  color: '#253289',
                  margin: 0,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <ShoppingOutlined /> Productos ({selectedInvoice.products?.length || 0})
                </Title>
              </div>

              <Table
                columns={productColumns.map(col => ({
                  ...col,
                  title: (
                    <span style={{
                      fontWeight: '600',
                      color: '#253289',
                      fontSize: '13px'
                    }}>
                      {col.title}
                    </span>
                  )
                }))}
                dataSource={selectedInvoice.products}
                pagination={false}
                rowKey="namegood"
                bordered={false}
                size="middle"
                style={{
                  background: 'white',
                  borderRadius: '8px'
                }}
              />
            </Card>
        </>
      )}
    </CustomModal>
  );
};

export default InvoiceDetailsModal;